import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { inr } from "@/theme";
import { useAdminTheme } from "@/admin/AdminTheme";
import { ACard, AdminPageTitle } from "@/admin/ui";
import { Spinner } from "@/components/common";

export default function AdminCustomers() {
  const { c } = useAdminTheme();
  const [customers, setCustomers] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api("/admin/customers").then(setCustomers).catch(() => setCustomers([])); }, []);
  if (!customers) return <Spinner full />;

  return (
    <div className="fade-up" style={{ maxWidth: 960 }}>
      <AdminPageTitle title="Customers" subtitle={`${customers.length} registered`} />
      <ACard style={{ padding: 0, overflow: "hidden" }}>
        {customers.length === 0 ? <p style={{ padding: 24, color: c.mutedText }}>No customers yet.</p> : customers.map((u) => (
          <div key={u.id} data-testid={`customer-${u.id}`} onClick={() => navigate(`/admin/customer/${u.id}`)}
            style={{ display: "flex", alignItems: "center", gap: 14, padding: "13px 18px", borderBottom: `1px solid ${c.divider}`, cursor: "pointer" }}>
            <div style={{ width: 40, height: 40, borderRadius: 999, background: c.primarySoft, color: c.primarySoftText, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, flexShrink: 0 }}>
              {u.name?.[0]?.toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{u.name}</div>
              <div className="clamp-1" style={{ fontSize: 12.5, color: c.mutedText }}>{u.email} · {u.mobile}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontWeight: 700 }}>{inr(u.total_spent || 0)}</div>
              <div style={{ fontSize: 12, color: c.mutedText }}>{u.orders_count || 0} orders</div>
            </div>
          </div>
        ))}
      </ACard>
    </div>
  );
}
